import {FC, useEffect} from 'react';
import { Button } from "@telegram-apps/telegram-ui";
import { useTranslation } from "react-i18next";
import {mainButton, secondaryButton} from "@telegram-apps/sdk-react";
import {setOnClickMainButton, setOnClickSecondaryButton} from "@/helpers/tgButtons.ts";

interface ReorderControlsProps {
  onSave: () => void;
  onCancel: () => void;
  isSaving: boolean;
}

export const ReorderControls: FC<ReorderControlsProps> = ({ onSave, onCancel, isSaving }) => {
  const { t } = useTranslation();

  useEffect(() => {
    setOnClickMainButton(async () => {
      onSave();
    })
    mainButton.setParams({
      isVisible: true,
      isLoaderVisible: isSaving,
      isEnabled: !isSaving,
      text: t('action.save'),
    });
    setOnClickSecondaryButton(async () => {
      onCancel();
    });
    if (secondaryButton.isSupported()) {
      secondaryButton.setParams({
        isVisible: true,
        isLoaderVisible: false,
        isEnabled: !isSaving,
        text: t('action.cancel'),
      });
    }


    return () => {
      mainButton.setParams({
        isVisible: false,
      });

      if (secondaryButton.isSupported()) {
        secondaryButton.setParams({
          isVisible: false,
        });
      }
    };
  }, [onSave, isSaving]);

  return (import.meta.env.MODE === 'development' &&
    <div className="flex gap-3 p-3 pt-5 pb-5">
      <Button 
        mode="bezeled" 
        stretched 
        onClick={onCancel}
        disabled={isSaving}
      >
        {t('action.cancel')}
      </Button>
      <Button 
        mode="filled" 
        stretched 
        onClick={onSave}
        loading={isSaving}
        disabled={isSaving}
      >
        {t('action.save')}
      </Button>
    </div>
  );
};